import React, { ChangeEvent } from 'react';
import { FormikContextType } from 'formik';
import InputMask from 'react-input-mask';
import { TextFieldProps } from '@material-ui/core';
import { ApariTextField } from 'components';

interface Props {
    control: string;
    formik: FormikContextType<any>;
}

const ApUniqueTaxpayerReference: React.FC<Props & TextFieldProps> = ({ control, formik, disabled, ...rest }) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => formik.setFieldValue(control, event.target.value);
    const inputMaskField = () => (
        <ApariTextField
            name={control}
            error={formik.touched[control] && Boolean(formik.errors[control])}
            helperText={formik.touched[control] && formik.errors[control]}
            variant="outlined"
            fullWidth
            disabled={disabled}
            margin="dense"
            {...rest}
        />
    );
    return (
        <InputMask
            mask="**********"
            maskPlaceholder=""
            disabled={disabled}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            maskChar=""
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            formatChars={{
                '9': '[0-9]',
                a: '[A-Za-z]',
                s: '[ABCDabcd]',
                '*': '[A-Za-z0-9]'
            }}
            onChange={handleChange}
            value={formik.values[control] ?? ''}
        >
            {inputMaskField}
        </InputMask>
    );
};

export default ApUniqueTaxpayerReference;
